<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      <span :class="$style['card__text--accent']">結婚式って、実際いくら</span
      >かかるの？
    </template>
    <template #detail>
      結婚にかかる具体的な費用項目やその総額を知りたい。他の人たちが結婚関連にどのくらいのお金を使ったのかも参考にしたい。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
